import { ChevronRight, House } from 'lucide-react';
import Button from '../../common/Button';
import Card from '../../common/Card';
import { useMemberApi } from '../../../hooks/useMemberApi';
import { MemberDTO } from '../../../services/apiClient';
import { MemberRegistrationStepConstants } from '../../../constants/MemberRegistrationStepConstants';

interface WelcomeProps {
  member: MemberDTO | undefined;
  onNext: () => void;
  // Called when the server rejects the step change (e.g. registration already completed in another tab)
  onStale?: () => void;
}

const Welcome: React.FC<WelcomeProps> = ({ member, onNext, onStale }) => {
  const { updateRegistrationStep } = useMemberApi();

  const handleContinue = async () => {
    try{
      if(member && member.id)
        await updateRegistrationStep(member.id, { memberRegistrationStepId: MemberRegistrationStepConstants.MEMBERSHIP });

      onNext();
    }catch(error){
      console.error("Error updating member", error);
      onStale?.();
    }
  }

  return (
    <Card>
      <div className="flex items-center justify-center">
        <div className="max-w-2xl w-full p-8 text-center">
          <div className="flex justify-center mb-6">
            <div className="w-24 h-24 bg-gray-50 rounded-full flex items-center justify-center">
              <House size={60} color="#299800ff" />
            </div>
          </div>
          <h2 className="text-2xl font-medium text-primary mb-4">
            Welcome to Natshoot
          </h2>
          <div className="space-y-2">
            <p className="text-lg text-primary">
              You are almost done with your registration.
            </p>
            <p className="text-lg text-primary">
              You will then gain access to the member portal.
            </p>
          </div>
          <div className="mt-4">
            <Button variant="primary" onClick={handleContinue}>
              Continue
              <ChevronRight />
            </Button>
          </div>
        </div>
      </div>
    </Card>
  );
};

export default Welcome;
